import { useEffect } from "react";
import { useAuth } from "../../app/auth/AuthContext";
import { useNavigate } from "react-router-dom";

export const Landing: React.FC = () => {
    const { dispatch } = useAuth();
    let navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
    
        if(token) {
          dispatch({ type: 'LOGIN_SUCCESS', payload: { token } });
          navigate('/gallery');
        }
      });


    return (
        <section className="landing">
        <h1>React TypeScript App</h1>
        <p>
            This is a React TypeScript application hosted on AWS S3 with CloudFront distribution.
        </p>
        </section>
    );
}